export default {
    methods: {
        normalizeAddress(address, callingModule) {
            if (!address) {
                return address;
            }

            let normalizedAddress;

            switch (callingModule) {
                case "profile":
                case "webcomponents-ui":
                    normalizedAddress = {
                        street: address.shippingAddress1 || "",
                        street2: address.shippingAddress2 || "",
                        district: address.shippingCounty || "",
                        city: address.shippingCity || "",
                        country: address.shippingCountry || "",
                        postalCode: address.shippingPostalCode || "",
                        region: address.shippingState || "",
                    };
                    break;
                default:
                    normalizedAddress = {
                        district: address.district || "",
                        city: address.city || "",
                        country: address.country || "",
                        postalCode: address.postalCode || "",
                        region: address.region || "",
                        street: address.address1 || "",
                        street2: address.address2 || "",
                    };

                    // When the address in Mexico lacks a value for street2, an exact match fails because the suggested address from the street address validator API does not include this field.
                    if (address.country == 'MX' && !normalizedAddress['street2']) delete normalizedAddress['street2'];
                    break;
            }

            return this.trimFields(normalizedAddress);
        },
        denormalizeAddress(address, callingModule) {
            if (!address) {
                return address;
            }

            let denormalizedAddress;

            switch (callingModule) {
                case "profile":
                case "webcomponents-ui":
                    denormalizedAddress = {
                        shippingAddress1: address.street || "",
                        shippingAddress2: address.street2 || "",
                        shippingCounty: address.district || "",
                        shippingCity: address.city || "",
                        shippingCountry: address.country || "",
                        shippingPostalCode: address.postalCode || "",
                        shippingState: address.region || "",
                    };
                    break;
                default:
                    denormalizedAddress = {
                        address1: address.street || "",
                        address2: address.street2 || "",
                        city: address.city || "",
                        district: address.district || "",
                        region: address.region || "",
                        postalCode: address.postalCode || "",
                        country: address.country || "",
                    };
                    break;
            }

            /*
             * Trimming the fields is still necessary, as these inputs are not "normalized" by the normalizeAddress
             * function. In order to maintain consistency, we trim here as well.
            */
            return this.trimFields(denormalizedAddress);
        },

        trimFields(input) {
            // Trim whitespace on all fields, if input is an object
            if (typeof input === "object") {
                const inputFields = Object.keys(input);

                if (inputFields.length > 0) {
                    inputFields.forEach(key => {
                        const value = input[key];

                        if (value && typeof value === "string") {
                            input[key] = value.trim();
                        }
                    });
                }
            }

            return input;
        },
    },
};
